module.exports = __webpack_public_path__ + "static/media/re.f458c651.jpg";